import {
  ISubscription,
  SubscriptionPackageRank,
  SubscriptionPackageTierRank
} from "@wingspanhq/users/dist/lib/interfaces/subscription";
import { openInNewTab } from "../../../shared/utils/openInNewTab";
import { WS_LINKS } from "../../../types/wsLinks";
import {
  IS_DEV_ENV,
  IS_PRODUCTION_ENV
} from "../../../shared/constants/environment";
import { isNumber } from "../../../utils";
import { ExtendedWebflowBenefit } from "../types";

export const createHealthSherpaLink = (zipCode: string) =>
  "https://www.healthsherpa.com/marketplace/applicants?_agent_id=wingspan";

export const sortCMSBenefits = (
  a: ExtendedWebflowBenefit,
  b: ExtendedWebflowBenefit
) => {
  if (isNumber(a.orderPriority) && isNumber(b.orderPriority)) {
    if (a.orderPriority > b.orderPriority) {
      return 1;
    } else if (a.orderPriority < b.orderPriority) {
      return -1;
    }
  } else if (isNumber(a.orderPriority)) {
    return 1;
  } else if (isNumber(b.orderPriority)) {
    return -1;
  }
  if (a.name > b.name) {
    return 1;
  } else if (a.name < b.name) {
    return -1;
  }
  return 0;
};

export const isBenefitHidden = (benefit: ExtendedWebflowBenefit): boolean =>
  !isBenefitVisibleInThisEnvironment(benefit) || !!benefit.hidden;

export const isBenefitAlwaysAdditional = (
  benefit: ExtendedWebflowBenefit
): boolean => !!benefit.isAdditionalCoverage;

export const isBenefitIncludedInSubscriptionLevel = (
  benefit: ExtendedWebflowBenefit,
  subscription?: ISubscription
): boolean => {
  if (!subscription) {
    return true;
  }

  if (
    SubscriptionPackageRank[subscription.package] >=
    SubscriptionPackageRank[benefit.minSubscriptionPackage]
  ) {
    return (
      SubscriptionPackageTierRank[subscription.packageTier] >=
      SubscriptionPackageTierRank[benefit.minSubscriptionPackageTier]
    );
  }
  return false;
};

export const getCostOfBenefitWithSubscription = (
  benefit: ExtendedWebflowBenefit,
  subscription?: ISubscription
): string => {
  return `${
    benefit.helperCostIsNotIncluded
      ? ``
      : `Included in subscription${
          !isBenefitIncludedInSubscriptionLevel(benefit, subscription)
            ? " (Premium)"
            : ""
        }`
  }${
    benefit.helperCostDescription
      ? `${benefit.helperCostIsNotIncluded ? `` : `, `}${
          benefit.helperCostDescription
        }`
      : ""
  }`;
};

export const insertMemberAndGroupIdsIntoText = (
  text: string,
  memberId?: string,
  groupId?: string
) => {
  return text
    .replaceAll("{{membershipId}}", memberId ? memberId : "---")
    .replaceAll("{{groupId}}", groupId ? groupId : "---");
};

export const isBenefitVisibleInThisEnvironment = (
  benefit: ExtendedWebflowBenefit
) => IS_DEV_ENV || (IS_PRODUCTION_ENV && !benefit.isDraft);

export const openMeridioGuidebook = () =>
  openInNewTab(WS_LINKS.meridioGuidebook);
